export const BuildInfo = {timestamp:1781192655000}
